import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { mdiGoogle } from "@mdi/js";
import Icon from "@mdi/react";
import { Button, notification } from "antd";
import { observer } from "mobx-react-lite";

import { api } from "../../api";
import { userStore } from "../../stores/userStore";
import { usePendingAction } from "../../utils/usePendingAction";

export const GoogleSocialAccount = observer(function GoogleSocialAccount() {
  const { t } = useTranslation();
  const { pending: unlinkLoading, run: runUnlink } = usePendingAction();
  const linkedAccount = userStore.profile?.integrations?.social_list?.find(
    (account) => account.id === "google",
  );
  const isLinked = linkedAccount !== undefined;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isGoogleAlreadyBound =
      params.get("oauth_account") === "already-bound" &&
      params.get("provider") !== "yandex";

    if (isGoogleAlreadyBound) {
      notification.error({
        message: t("profile.socialAccounts.alreadyBound"),
      });
      const url = new URL(window.location.href);
      url.searchParams.delete("oauth_account");
      window.history.replaceState(null, "", url.toString());
      return;
    }

    if (sessionStorage.getItem("pendingSocialLink") !== "google") return;
    sessionStorage.removeItem("pendingSocialLink");
    if (isLinked) {
      notification.success({
        message: t("profile.socialAccounts.linkSuccess"),
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function handleUnlink() {
    await runUnlink(async () => {
      try {
        await api.integration.unlinkGoogle();
        const updatedProfile = await api.profile.getProfile();
        userStore.setProfile(updatedProfile);
        notification.success({
          message: t("profile.socialAccounts.unlinkSuccess"),
        });
      } catch {
        notification.error({ message: t("errors.shared.common_error") });
      }
    });
  }

  if (isLinked) {
    return (
      <div className="social-accounts__row">
        <a
          className="social-accounts__chip"
          href="https://myaccount.google.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={
            linkedAccount.value === null
              ? "Google"
              : `Google: ${linkedAccount.value}`
          }
        >
          <span className="social-accounts__icon">
            <Icon path={mdiGoogle} size={0.9} color="#fff" />
          </span>
          {linkedAccount.value !== null && (
            <span className="social-accounts__chip-value">
              {linkedAccount.value}
            </span>
          )}
        </a>
        <Button size="large" loading={unlinkLoading} onClick={handleUnlink}>
          {t("profile.socialAccounts.unlink")}
        </Button>
      </div>
    );
  }

  return (
    <div className="social-accounts__row">
      <span className="social-accounts__icon">
        <Icon path={mdiGoogle} size={0.9} color="#fff" />
      </span>
      <Button
        size="large"
        style={{ height: 36 }}
        onClick={() => {
          sessionStorage.setItem("pendingSocialLink", "google");
          window.location.href = "/google/login/?process=connect&next=/";
        }}
      >
        {t("profile.socialAccounts.link")}
      </Button>
    </div>
  );
});
